(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["contact-form"] && !Shopify.designMode) return;
  try {
    (function() {
    function resetForms() {
      document.querySelectorAll('form[id^="ContactForm-"]').forEach(function(f) {
        f.reset();
        f.querySelectorAll('input, textarea').forEach(function(el) {
          if (!el.hasAttribute('readonly')) el.setAttribute('readonly', true);
          el.addEventListener('focus', function() { this.removeAttribute('readonly'); }, { once: true });
        });
      });
    }
    document.addEventListener('DOMContentLoaded', resetForms);
    window.addEventListener('load', function() { setTimeout(resetForms, 150); });
    window.addEventListener('pageshow', function(e) { if (e.persisted) resetForms(); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form-book-class"] && !Shopify.designMode) return;
  try {
    (function() {
    function resetForm() {
      var f = document.getElementById('BookClassForm');
      if (!f) return;
      f.reset();
      f.querySelectorAll('input, textarea, select').forEach(function(el) {
        if (!el.hasAttribute('readonly')) el.setAttribute('readonly', true);
        el.addEventListener('focus', function() { this.removeAttribute('readonly'); }, { once: true });
      });
    }
    document.addEventListener('DOMContentLoaded', resetForm);
    window.addEventListener('load', function() { setTimeout(resetForm, 150); });
    window.addEventListener('pageshow', function(e) { if (e.persisted) resetForm(); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form-custom-order"] && !Shopify.designMode) return;
  try {
    (function() {
    function resetForm() {
      var f = document.getElementById('CustomOrderForm');
      if (!f) return;
      f.reset();
      f.querySelectorAll('input, textarea').forEach(function(el) {
        if (!el.hasAttribute('readonly')) el.setAttribute('readonly', true);
        el.addEventListener('focus', function() { this.removeAttribute('readonly'); }, { once: true });
      });
    }
    document.addEventListener('DOMContentLoaded', resetForm);
    window.addEventListener('load', function() { setTimeout(resetForm, 150); });
    window.addEventListener('pageshow', function(e) { if (e.persisted) resetForm(); });
  })();
  } catch(e) { console.error(e); }
})();

})();
